<template>
    <div>
        <Head title="Token Transaction | Wallet" />

        <heading>
            <template #heading>
                <Link :href="route('wallet.show')" class="flex items-center hover:text-indigo-600 space-x-1">
                    <svg xmlns="http://www.w3.org/2000/svg" class="w-8 h-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 17l-5-5m0 0l5-5m-5 5h12" />
                    </svg>
                    <span>Token Transaction</span>
                </Link>
            </template>
        </heading>

        <div class="bg-gray-100">
            <div>
                <div class="px-4 space-y-2 sm:flex sm:items-baseline sm:justify-between sm:px-0 sm:space-y-0">
                    <div class="flex sm:items-center sm:space-x-4">
                        <h1 class="text-gray-900 text-lg font-bold tracking-tight sm:text-xl">Transaction #{{ transaction.id }}</h1>
                        <a :href="paymentIntent.receiptUrl" target="_blank" class="hidden hover:text-indigo-500 text-indigo-600 text-sm font-medium sm:block">View receipt<span aria-hidden="true"> &rarr;</span></a>
                    </div>
                    <p class="text-gray-600 text-sm">
                        Date Paid
                        <time :datetime="transaction.createdAt" class="text-gray-700 font-medium">{{ transaction.createdAt | dateFormat("MMM D, h:mm A") }}</time>
                    </p>
                    <a :href="paymentIntent.receiptUrl" target="_blank" class="hover:text-indigo-500 text-indigo-600 text-sm font-medium sm:hidden">View receipt<span aria-hidden="true"> &rarr;</span></a>
                </div>

                <!-- Billing -->
                <div class="mt-6">
                    <h2 class="sr-only">Billing Summary</h2>

                    <div class="px-4 py-6 bg-gray-50 sm:px-6 sm:rounded-lg lg:grid lg:gap-x-8 lg:grid-cols-12 lg:px-8 lg:py-8">
                        <dl class="flex grid gap-6 grid-cols-2 items-center text-sm sm:grid-cols-2 md:gap-x-8 lg:col-span-7">
                            <div>
                                <dt class="text-gray-900 font-medium">Postal Code</dt>
                                <dd class="mt-3 text-gray-500">
                                    <span class="block">{{ paymentIntent.postalCode }}</span>
                                </dd>
                            </div>
                            <div>
                                <dt class="text-gray-900 font-medium">Payment Method</dt>
                                <div class="mt-3">
                                    <dd class="flex flex-wrap -ml-4 -mt-4">
                                        <div class="flex-shrink-0 ml-4 mt-4">
                                            <svg aria-hidden="true" width="36" height="24" viewBox="0 0 36 24" xmlns="http://www.w3.org/2000/svg" class="w-auto h-6">
                                                <rect width="36" height="24" rx="4" fill="#224DBA" />
                                                <path
                                                    d="M10.925 15.673H8.874l-1.538-6c-.073-.276-.228-.52-.456-.635A6.575 6.575 0 005 8.403v-.231h3.304c.456 0 .798.347.855.75l.798 4.328 2.05-5.078h1.994l-3.076 7.5zm4.216 0h-1.937L14.8 8.172h1.937l-1.595 7.5zm4.101-5.422c.057-.404.399-.635.798-.635a3.54 3.54 0 011.88.346l.342-1.615A4.808 4.808 0 0020.496 8c-1.88 0-3.248 1.039-3.248 2.481 0 1.097.969 1.673 1.653 2.02.74.346 1.025.577.968.923 0 .519-.57.75-1.139.75a4.795 4.795 0 01-1.994-.462l-.342 1.616a5.48 5.48 0 002.108.404c2.108.057 3.418-.981 3.418-2.539 0-1.962-2.678-2.077-2.678-2.942zm9.457 5.422L27.16 8.172h-1.652a.858.858 0 00-.798.577l-2.848 6.924h1.994l.398-1.096h2.45l.228 1.096h1.766zm-2.905-5.482l.57 2.827h-1.596l1.026-2.827z"
                                                    fill="#fff"
                                                />
                                            </svg>
                                            <p class="sr-only">Visa</p>
                                        </div>
                                        <div class="ml-4 mt-4">
                                            <p class="text-gray-900">Ending with {{ paymentIntent.last4 }}</p>
                                            <p class="text-gray-600">Expires {{ paymentIntent.expMonth | padStart(2, 0) }} / {{ paymentIntent.expYear }}</p>
                                        </div>
                                    </dd>
                                </div>
                            </div>
                        </dl>

                        <dl class="mt-8 text-sm divide-gray-200 divide-y lg:col-span-5 lg:mt-0">
                            <div class="flex items-center justify-between pb-4">
                                <dt class="text-gray-900 font-medium">Purchased</dt>
                                <dd class="text-gray-600">{{ transaction.amount }} tokens</dd>
                            </div>
                            <div class="flex items-center justify-between pt-4">
                                <dt class="text-gray-900 font-medium">Amount Paid</dt>
                                <dd class="text-indigo-600 font-medium">{{ transaction.amount | currency }}.00</dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "@/Layouts/AppLayout"
import Heading from "@/Components/Heading"

export default {
    name: "TokenTransaction",
    components: { Heading },
    layout: AppLayout,

    props: {
        transaction: {
            type: Object,
            required: true,
        },
        paymentIntent: {
            type: Object,
        },
    },
}
</script>
